import { get, flowRight } from 'lodash';
import { connect } from 'react-redux';
import { withCustomMetrics } from '@zocdoc/frontend-metrics';
import { BOOKING_CONTAINER_ROOT_KEY } from '../../constants';
import { ModalContentView } from './ModalContentView';

export const mapStateToProps = (state = {}) => {
    return {
        headerText: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'modalContent.headerText'
        ),
        descriptionText: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'modalContent.descriptionText'
        ),
        primaryButtonText: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'modalContent.primaryButtonText'
        ),
        secondaryButtonText: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'modalContent.secondaryButtonText'
        ),
        onClickPrimaryButton: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'modalContent.onClickPrimaryButton'
        ),
        onClickSecondaryButton: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'modalContent.onClickSecondaryButton'
        ),
    };
};
export const ModalContentConnector = flowRight(
    connect(mapStateToProps),
    withCustomMetrics({
        page: 'Booking',
    })
)(ModalContentView);
